let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("egHGn")).then(() => parcelRequire('9zGp3'));